import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
// import configJson from './static/config'

Vue.use(Router)

export default new Router({
  // mode: 'history',
  // base: configJson.publishFolder,
  routes: [
    {
      path: '/Login',
      name: 'login',
      component: () => import(/* webpackChunkName: "city" */ './views/zh/Login.vue')
    },
    {
      path: '/book',
      name: 'book',
      component: () => import(/* webpackChunkName: "city" */ './views/en/book.vue')
    },
    {
      path: '/LoginEN',
      name: 'logine',
      component: () => import(/* webpackChunkName: "city" */ './views/en/Login.vue')
    },
    {
      path: '/',
      name: 'home',
      redirect: '/Login',
      component: Home
    },
    {
      path: '/city',
      name: 'city',
      component: () => import(/* webpackChunkName: "city" */ './views/zh/City.vue')
    },
    {
      path: '/cityD',
      name: 'cityD',
      component: () => import(/* webpackChunkName: "cityD" */ './views/zh/cityD.vue')
    },
    {
      path: '/cityA1',
      name: 'cityA1',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "CityA1" */ './views/zh/CityA1.vue')
    },
    {
      path: '/cityA3',
      name: 'cityA3',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "CityA3" */ './views/zh/CityA3.vue')
    },
    {
      path: '/cityA2',
      name: 'cityA2',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "CityA2" */ './views/zh/CityA2.vue')
    },
    {
      path: '/cityA4',
      name: 'cityA4',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "CityA4" */ './views/zh/CityA4.vue')
    },
    {
      path: '/cityA6',
      name: 'cityA6',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "CityA6" */ './views/zh/CityA6.vue')
    },
    {
      path: '/cityE1',
      name: 'cityE1',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "CityE1" */ './views/zh/CityE1.vue')
    },
    {
      path: '/cityE2',
      name: 'cityE2',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "CityE2" */ './views/zh/CityE2.vue')
    },
    {
      path: '/cityE3',
      name: 'cityE3',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "CityE3" */ './views/zh/CityE3.vue')
    },
    {
      path: '/cityF1',
      name: 'cityF1',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "CityF1" */ './views/zh/CityF1.vue')
    },
    {
      path: '/cityE5',
      name: 'cityE5',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "CityE5" */ './views/zh/CityE5.vue')
    },
    {
      path: '/cityE4',
      name: 'cityE4',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "CityE4" */ './views/zh/CityE4.vue')
    },
    {
      path: '/cityDe',
      name: 'cityDe',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "cityDe" */ './views/en/cityD.vue')
    },
    {
      path: '/cityA1e',
      name: 'cityA1e',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "CityA1e" */ './views/en/CityA1.vue')
    },
    {
      path: '/cityA3e',
      name: 'cityA3e',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "CityA3e" */ './views/en/CityA3.vue')
    },
    {
      path: '/cityA2e',
      name: 'cityA2e',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "CityA2e" */ './views/en/CityA2.vue')
    },
    {
      path: '/cityA4e',
      name: 'cityA4e',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "CityA4e" */ './views/en/CityA4.vue')
    },
    {
      path: '/cityA6e',
      name: 'cityA6e',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "CityA6e" */ './views/en/CityA6.vue')
    },
    {
      path: '/cityE1e',
      name: 'cityE1e',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "CityE1e" */ './views/en/CityE1.vue')
    },
    {
      path: '/cityE2e',
      name: 'cityE2e',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "CityE2e" */ './views/en/CityE2.vue')
    },
    {
      path: '/cityE3e',
      name: 'cityE3e',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "CityE3e" */ './views/en/CityE3.vue')
    },
    {
      path: '/cityF1e',
      name: 'cityF1e',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "CityF1e" */ './views/en/CityF1.vue')
    },
    {
      path: '/cityE5e',
      name: 'cityE5e',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "CityE5e" */ './views/en/CityE5.vue')
    },
    {
      path: '/cityE4e',
      name: 'cityE4e',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "CityE4e" */ './views/en/CityE4.vue')
    },
    {
      path: '/cityB1',
      name: 'cityB1',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "cityB1" */ './views/zh/CityB1.vue')
    },
    {
      path: '/cityB1e',
      name: 'cityB1e',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "cityB1e" */ './views/en/CityB1.vue')
    },
    {
      path: '/cityB2',
      name: 'cityB2',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "cityB3" */ './views/zh/CityB2.vue')
    },
    {
      path: '/cityB2e',
      name: 'cityB2e',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "cityB3" */ './views/en/CityB2.vue')
    },
    {
      path: '/cityB3',
      name: 'cityB3',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "cityB3" */ './views/zh/CityB3.vue')
    },
    {
      path: '/cityB3e',
      name: 'cityB3e',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "cityB3" */ './views/en/CityB3.vue')
    },
    {
      path: '/cityCe',
      name: 'cityCe',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "cityCe" */ './views/en/CityC.vue')
    },
    {
      path: '/cityCCe',
      name: 'cityCCe',
      component: () => import(/* webpackChunkName: "cityCC" */ './views/en/CityCC.vue')
    },
    {
      path: '/cityC1',
      name: 'cityC1',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "cityC1" */ './views/outside/smartcity.vue')
    },
    {
      path: '/cityC2',
      name: 'cityC2',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "cityC2" */ './views/outside/cjsz.vue')
    },
    {
      path: '/cityC3',
      name: 'cityC3',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "cityC3" */ './views/outside/shenzhenmake.vue')
    },
    {
      path: '/cityC4',
      name: 'cityC4',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "cityC4" */ './views/outside/englishmatch.vue')
    },
    {
      path: '/cityC5',
      name: 'cityC5',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "cityC5" */ './views/outside/agreement.vue')
    },
    {
      path: '/cityC6',
      name: 'cityC6',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "cityC6" */ './views/outside/newage.vue')
    },
    {
      path: '/cityC7',
      name: 'cityC7',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "cityC7" */ './views/outside/shenzhenwalk.vue')
    },
    {
      path: '/Activities',
      name: 'cityQ1',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "cityQ1" */ './views/zh/CityQ1.vue')
    },
    {
      path: '/ActivitiesEN',
      name: 'cityQ1e',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "cityQ1e" */ './views/en/CityQ1.vue')
    },
    {
      path: '/activitylist',
      name: 'cityQ2',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "cityQ2" */ './views/zh/CityQ2.vue')
    },
    {
      path: '/activitylistEN',
      name: 'cityQ2e',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "cityQ2e" */ './views/en/CityQ2.vue')
    },
    {
      path: '/sponsorlist',
      name: 'cityQ3',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "cityQ3" */ './views/zh/CityQ3.vue')
    },
    {
      path: '/sponsorlistEN',
      name: 'cityQ3e',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "cityQ3e" */ './views/en/CityQ3.vue')
    },
    {
      path: '/sponsor',
      name: 'cityQ4',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "cityQ4" */ './views/zh/CityQ4.vue')
    },
    {
      path: '/sponsorEN',
      name: 'cityQ4e',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "cityQ4e" */ './views/en/CityQ4.vue')
    },
    {
      path: '/activity',
      name: 'cityQ5',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "cityQ5" */ './views/zh/CityQ5.vue')
    },
    {
      path: '/activityEN',
      name: 'cityQ5e',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "cityQ5e" */ './views/en/CityQ5.vue')
    },
    {
      path: '/create',
      name: 'cityQ6',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "cityQ6" */ './views/zh/CityQ6.vue')
    },
    {
      path: '/createEN',
      name: 'cityQ6e',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "cityQ6e" */ './views/en/CityQ6.vue')
    },
    {
      path: '/user',
      name: 'cityG',
      redirect: '/user/index',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "cityG" */ '@/views/zh/CityG.vue'),
      children: [
        {
          path: 'index',
          name: 'cityG1',
          component: () => import(/* webpackChunkName: "cityG1" */ '@/views/zh/CityG1.vue')
        },
        {
          path: 'eventadmin',
          name: 'cityG2',
          component: () => import(/* webpackChunkName: "cityG1" */ '@/views/zh/CityG2.vue')
        },
        {
          path: 'attendees',
          name: 'cityG2A',
          component: () => import(/* webpackChunkName: "cityG2A" */ './views/zh/CityG2A.vue')
        },
        {
          path: 'signnote',
          name: 'cityG2b',
          component: () => import(/* webpackChunkName: "CityG2b" */ './views/zh/CityG2b.vue')
        },
        {
          path: 'participate',
          name: 'cityG3',
          component: () => import(/* webpackChunkName: "cityG1" */ './views/zh/CityG3.vue')
        },
        {
          path: 'collection',
          name: 'cityG4',
          component: () => import(/* webpackChunkName: "cityG1" */ './views/zh/CityG4.vue')
        },
        {
          path: 'sponsorcollection',
          name: 'cityG5',
          component: () => import(/* webpackChunkName: "cityG1" */ './views/zh/CityG5.vue')
        },
        {
          path: 'authentication',
          name: 'cityG6',
          component: () => import(/* webpackChunkName: "cityG1" */ './views/zh/CityG6.vue')
        },
        {
          path: 'profile',
          name: 'cityG7',
          component: () => import(/* webpackChunkName: "cityG1" */ './views/zh/CityG7.vue')
        },
        {
          path: 'changepwd',
          name: 'cityG8',
          component: () => import(/* webpackChunkName: "cityG1" */ './views/zh/CityG8.vue')
        }
      ]
    },
    {
      path: '/userEN',
      name: 'cityGe',
      redirect: '/userEN/indexEN',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "cityGe" */ '@/views/en/CityG.vue'),
      children: [
        {
          path: 'indexEN',
          name: 'cityG1e',
          component: () => import(/* webpackChunkName: "cityG1e" */ '@/views/en/CityG1.vue')
        },
        {
          path: 'eventadminEN',
          name: 'cityG2e',
          component: () => import(/* webpackChunkName: "cityG1e" */ '@/views/en/CityG2.vue')
        },
        {
          path: 'attendeesEN',
          name: 'cityG2Ae',
          component: () => import(/* webpackChunkName: "cityG2Ae" */ './views/en/CityG2A.vue')
        },
        {
          path: 'signnoteEN',
          name: 'cityG2be',
          component: () => import(/* webpackChunkName: "CityG2be" */ './views/en/CityG2b.vue')
        },
        {
          path: 'participateEN',
          name: 'cityG3e',
          component: () => import(/* webpackChunkName: "cityG3e" */ './views/en/CityG3.vue')
        },
        {
          path: 'collectionEN',
          name: 'cityG4e',
          component: () => import(/* webpackChunkName: "cityG4e" */ './views/en/CityG4.vue')
        },
        {
          path: 'sponsorcollectionEN',
          name: 'cityG5e',
          component: () => import(/* webpackChunkName: "cityG5e" */ './views/en/CityG5.vue')
        },
        {
          path: 'authenticationEN',
          name: 'cityG6e',
          component: () => import(/* webpackChunkName: "cityG6e" */ './views/en/CityG6.vue')
        },
        {
          path: 'profileEN',
          name: 'cityG7e',
          component: () => import(/* webpackChunkName: "cityG7e" */ './views/en/CityG7.vue')
        },
        {
          path: 'changepwdEN',
          name: 'cityG8e',
          component: () => import(/* webpackChunkName: "cityG8" */ './views/en/CityG8.vue')
        }
      ]
    },
    // {
    //   path: '/cityP',
    //   name: 'cityP',
    //   // route level code-splitting
    //   // this generates a separate chunk (about.[hash].js) for this route
    //   // which is lazy-loaded when the route is visited.
    //   component: () => import(/* webpackChunkName: "cityP" */ './views/zh/CityP.vue')
    // },
    {
      path: '/Register',
      name: 'cityZ1',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "CityZ1" */ './views/zh/CityZ1.vue')
    },
    {
      path: '/RegisterEN',
      name: 'cityZ1e',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "CityZ1e" */ './views/en/CityZ1.vue')
    },
    {
      path: '/Forget',
      name: 'cityZ2',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "CityZ2" */ './views/zh/CityZ2.vue')
    },
    {
      path: '/ForgetEN',
      name: 'cityZ2e',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "CityZ2e" */ './views/en/CityZ2.vue')
    },
    {
      path: '/code',
      name: 'code',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "cityQ6" */ './views/zh/codeTicket.vue')
    },
    {
      path: '/codeEN',
      name: 'codee',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "cityQ6e" */ './views/en/codeTicket.vue')
    },
    {
      path: '/Agreement',
      name: 'Agreement',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "Agreement" */ './views/zh/Agreement.vue')
    },
    {
      path: '/AgreementEN',
      name: 'Agreemente',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "Agreemente" */ './views/en/Agreement.vue')
    },
    {
      path: '/Policy',
      name: 'Policy',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "Policy" */ './views/zh/policy.vue')
    },
    {
      path: '/PolicyEN',
      name: 'Policye',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "Policye" */ './views/en/policy.vue')
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    // return 期望滚动到哪个的位置
    return { x: 0, y: 0 }
  }
})
